import defaultState from './state'
import Vue from 'vue'
export default {
  setIsCallingExports: (state, payload) => { state.isCallingExports = payload },
  setExports: (state, payload) => {
    state.exports = payload
  },
  setCurrentExport: (state, payload) => {
    state.export = payload
  },
  updateCurrentExport: (state, payload) => {
    state.export = payload
  },
  setExportationFlows: (state, payload) => {
    if (state.exportationFlowsCurrentPage === 1) {
      state.exportationFlows = payload
    } else {
      state.exportationFlows.push(...payload)
    }
  },
  setExportationFlow: (state, payload) => {
    state.exportationFlow = payload
  },
  setErps: (state, payload) => {
    if (state.erpsCurrentPage === 1) {
      state.erps = payload
    } else {
      state.erps.push(...payload)
    }
  },
  addExportationFlow: (state, payload) => {
    const { id } = payload
    const exportationFlowToFindIndex = state.exportationFlows.findIndex(el => el.id === id)
    if (exportationFlowToFindIndex !== -1) {
      state.exportationFlows.splice(exportationFlowToFindIndex, 1, payload)
    } else {
      state.exportationFlows.push(payload)
    }
  },
  deleteExportationFlow: (state, id) => {
    const exportationFlowToFindIndex = state.exportationFlows.findIndex(el => el.id === id)
    state.exportationFlows.splice(exportationFlowToFindIndex, 1)
  },
  setExportHistory: (state, payload) => {
    state.exportHistory = payload
  },
  setExportsHistory: (state, payload) => {
    if (state.exportsHistoryCurrentPage === 1) {
      state.exportsHistory = payload
    } else {
      state.exportsHistory.push(...payload)
    }
  },
  setExportsHistoryLastPage: (state, payload) => { state.exportsHistoryLastPage = payload },
  setExportsHistoryFilters: (state, payload) => { state.exportsHistoryFilters = payload },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
